import React, { useState } from 'react';
import './App.css';
import { auth } from './firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import Header from './components/Header';
import SignIn from './components/SignIn';
import ChatRoom from './components/ChatRoom';

function App() {
  const [user] = useAuthState(auth);
  const [messageCount, setMessageCount] = useState(null);

  return (
    <div className="app">
      <Header messageCount={user ? messageCount : null} user={user} />
      <section className="app-section">
        {user ? (
          <ChatRoom onMessageCountChange={setMessageCount} />
        ) : (
          <SignIn />
        )}
      </section>
    </div>
  );
}

export default App;
